import React from 'react';
import { Theme } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import Meta from '@bizapp-lp/pjr/organisms/Meta';
import MarketoSimpleForm, {
  MarketoSimpleFormProps,
} from '@bizapp-lp/pjr/templates/MarketoSimpleForm';

const useStyle = makeStyles((theme: Theme) =>
  createStyles({
    lineBreaks: {
      display: 'block',
    },
  }),
);

const title =
  'Project Room お問い合わせ | 社内外とのプロジェクトを複数同時に進める現場のコラボレーションを支援・促進します';
const description =
  'Project Roomは、プロジェクトのための、簡単・安全に利用できるコミュニケーションツール。社外関係者も含めたプロジェクトメンバー全体のコミュニケーションを活性化し、エンゲージメントを向上します。プロジェクトで取り扱うファイルや予定の共有も一か所に集約でき、情報共有やノウハウ蓄積、共同作業をサポートします。';

export interface ContactProps
  extends Pick<MarketoSimpleFormProps, 'marketoForm'> {
  grecaptchaKey?: string;
}

const Contact: React.FC<ContactProps> = ({ grecaptchaKey, marketoForm }) => {
  const classes = useStyle();
  return (
    <GoogleReCaptchaProvider reCaptchaKey={grecaptchaKey}>
      <Meta>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
      </Meta>
      <MarketoSimpleForm
        heading="Project Room お問い合わせ"
        description={
          <>
            <span className={classes.lineBreaks}>
              下記フォームにご記入ください。
            </span>
            <span className={classes.lineBreaks}>
              フォーム送信後、弊社よりご案内をお送りいたします。
            </span>
          </>
        }
        marketoForm={{
          ...marketoForm,
          formName: 'pjr_contact',
        }}
      />
    </GoogleReCaptchaProvider>
  );
};

export default Contact;
